import {
  useVariantCardContext,
  useVariantConfigurationContext,
} from 'modules/experiments/contexts';
import { deletingCardState } from 'modules/experiments/constants';
import { Skeleton } from 'ui/skeleton';
import { FormField } from './FormField';
import { VariantBodyWrapper } from './Styled';

export const VariantBody = () => {
  const { formFieldSchema } = useVariantConfigurationContext();
  const { deletingCard } = useVariantCardContext();

  return (
    <VariantBodyWrapper>
      {formFieldSchema.map((formField) =>
        deletingCardState.includes(deletingCard) ? (
          <Skeleton key={formField.key} height={25} />
        ) : (
          <FormField key={formField.key} formField={formField} />
        ),
      )}
    </VariantBodyWrapper>
  );
};
